import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@aimsos/auth';
import { WorkspacesProviderWrapper } from './context';
import WorkspacesListPage from './pages/WorkspacesListPage';
import WorkspaceDetailPage from './pages/WorkspaceDetailPage';
import WorkspaceOverviewPage from './pages/WorkspaceOverviewPage';
import WorkspaceUsersPage from './pages/WorkspaceUsersPage';
import WorkspaceActivityLogPage from './pages/WorkspaceActivityLogPage';

/**
 * Domain root for Workspaces.
 * Owns internal routes and wraps with providers.
 *
 * Paths are RELATIVE to the parent route that mounts this component:
 *   - Shell:      <Route path="workspaces/*">
 *   - Standalone: <Route path="workspaces/*"> in main.jsx
 */
const Workspaces = () => (
  <WorkspacesProviderWrapper>
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute>
            <WorkspacesListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path=":workspaceId"
        element={
          <ProtectedRoute>
            <WorkspaceDetailPage />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview" element={<WorkspaceOverviewPage />} />
        <Route path="users" element={<WorkspaceUsersPage />} />
        <Route path="activity-log" element={<WorkspaceActivityLogPage />} />
      </Route>
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  </WorkspacesProviderWrapper>
);

export default Workspaces;
